import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Academy from "@/pages/Academy";
import ProgramsPage from "@/pages/ProgramsPage";
import LibraryPage from "@/pages/LibraryPage";
import Books from "@/pages/Books";
import Podcast from "@/pages/Podcast";
import Events from "@/pages/Events";
import FounderPage from "@/pages/FounderPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/academy" element={<Academy />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/library" element={<LibraryPage />} />
          <Route path="/books" element={<Books />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/events" element={<Events />} />
          <Route path="/founder" element={<FounderPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
